




import Vue from 'vue';
import IntakeForm from '@/components/IntakeForm.vue'; // @ is an alias to /src

export default Vue.extend({
  name: 'home',
  components: {
    IntakeForm,
  },
});

